(function () {
  if (window.MairazFocusedSearch) return;
  window.MairazFocusedSearch = true;

  function clean(value) {
    return String(value || '').replace(/["\\]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function originalTerm(value) {
    var match = String(value || '').match(/^title:"([^"]+)"\s+OR\s+tag:"\1"$/i);
    return match ? match[1] : value;
  }

  function prepare(form) {
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    input.value = originalTerm(input.value);

    var type = form.querySelector('input[name="type"]');
    if (!type) {
      type = document.createElement('input');
      type.type = 'hidden';
      type.name = 'type';
      form.appendChild(type);
    }
    type.value = 'product';

    form.addEventListener('submit', function () {
      var term = clean(input.value);
      if (!term) return;
      input.value = 'title:"' + term + '" OR tag:"' + term + '"';
    });
  }

  function boot() {
    document.querySelectorAll('form[role="search"][action*="/search"]').forEach(prepare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
